import { render, staticRenderFns } from "./ToolbarComponent.vue?vue&type=template&id=5c6aa7f1&scoped=true"
import script from "./ToolbarComponent.vue?vue&type=script&lang=js"
export * from "./ToolbarComponent.vue?vue&type=script&lang=js"
import style0 from "./ToolbarComponent.vue?vue&type=style&index=0&id=5c6aa7f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6aa7f1",
  null
  
)

export default component.exports